import { Dispatch, SetStateAction } from 'react';
import { Icon, IconsEnum } from '../../../../../../components/Icons';

import styles from './SlotArchiveFiltersModalHeader.module.scss';

export type SlotArchiveFiltersModalHeaderProps = {
  title: string;
  setOn: Dispatch<SetStateAction<boolean>>;
};

export const SlotArchiveFiltersModalHeader = ({ title, setOn }: SlotArchiveFiltersModalHeaderProps) => {
  return (
    <div className={styles.header}>
      <div className={styles.titleContainer}>
        <strong className={styles.title} suppressHydrationWarning>
          {title}
        </strong>
        <button
          type="button"
          className={styles.button}
          suppressHydrationWarning
          onClick={() => {
            setOn(false);
          }}
        >
          <Icon iconId={IconsEnum.CLOSE} className={styles.titleIcon} color="var(--color-on-bg-primary)" />
        </button>
      </div>
    </div>
  );
};
